// DeliveryAnalyticsPage.js
// ---------------------------------------------------------------------------
// Delivery analytics — top-level rail button, no longer a flyout.
//
// Three tabs over three screens that used to be three separate menu entries:
//   Analytics       -> Analytics.js          (small multi-chart overview)
//   Summary         -> DeliveryActivity.js   (per-day bar chart, by site/driver)
//   Delivery rounds -> route_analysis.js     (per-round route efficiency)
//
// Each tab is exactly the screen it always was — nothing about how any of the
// three works has changed, only where they live in the menu. They are still
// swapped with a plain conditional (not left mounted-and-hidden), so a tab you
// switch away from and back to re-fetches fresh data rather than showing a
// stale snapshot — the same behaviour every other top-level page already has
// when you navigate away and back via the rail.
// ---------------------------------------------------------------------------
import React, { useState } from "react";
import Analytics from "./Analytics";
import DeliveryActivity from "./DeliveryActivity";
import RouteAnalysis from "./route_analysis";

const TABS = [
  { key: "analytics", label: "Analytics" },
  { key: "summary",   label: "Summary" },
  { key: "rounds",    label: "Delivery rounds" },
];

const S = {
  tabBar: { display: "flex", gap: 6, padding: "16px 16px 0", flexWrap: "wrap" },
  btn: {
    background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db",
    borderRadius: 8, padding: "6px 14px", fontSize: 13, cursor: "pointer",
    fontFamily: "inherit", fontWeight: 500,
  },
  btnActive: { background: "#1976d2", color: "#fff", borderColor: "#1976d2", fontWeight: 600 },
};

export default function DeliveryAnalyticsPage({ token, userData }) {
  const [tab, setTab] = useState("analytics");

  return (
    <div>
      <div style={S.tabBar}>
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{ ...S.btn, ...(tab === t.key ? S.btnActive : {}) }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "analytics" && <Analytics token={token} />}
      {tab === "summary" && <DeliveryActivity userData={userData} token={token} />}
      {tab === "rounds" && <RouteAnalysis />}
    </div>
  );
}
